var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(_vm.src)?_c('div',_vm._g(_vm._b({staticClass:"product-class mr-4"},'div',attrs,false),on),[_c('img',{attrs:{"aria-hidden":"","alt":_vm.pClass.name,"src":_vm.src}})]):_vm._e()]}}])},[_c('span',[_vm._v(_vm._s(_vm.pClass.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }